module.exports = __webpack_public_path__ + "img/xr.d896da18.png";